import { render, staticRenderFns } from "./ModificationProfil.vue?vue&type=template&id=5e49a45d&scoped=true"
import script from "./ModificationProfil.vue?vue&type=script&lang=js"
export * from "./ModificationProfil.vue?vue&type=script&lang=js"
import style0 from "./ModificationProfil.vue?vue&type=style&index=0&id=5e49a45d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e49a45d",
  null
  
)

export default component.exports